export function drawFrequencyBars(canvasContext, canvas, dataArray) {
  const totalBars = 24;
  const spacing = 9;
  const cornerRadius = 5;
  const minBarHeight = 15;

  canvasContext.clearRect(0, 0, canvas.width, canvas.height);

  const actualBarWidth =
    (canvas.width - (totalBars - 1) * spacing) / totalBars;

  for (let i = 0; i < totalBars / 2; i++) {
    const barHeight = Math.max(
      (dataArray[i] / 220) * (canvas.height / 2),
      minBarHeight,
    );

    const leftX = canvas.width / 2 - (i + 1) * (actualBarWidth + spacing);
    const rightX = canvas.width / 2 + i * (actualBarWidth + spacing);

    canvasContext.fillStyle = "#3FC678";

    drawRoundedRect(
      canvasContext,
      leftX,
      canvas.height / 2 - barHeight,
      actualBarWidth,
      barHeight,
      cornerRadius,
      true,
      false,
    );

    drawRoundedRect(
      canvasContext,
      leftX,
      canvas.height / 2,
      actualBarWidth,
      barHeight,
      cornerRadius,
      false,
      true,
    );

    drawRoundedRect(
      canvasContext,
      rightX,
      canvas.height / 2 - barHeight,
      actualBarWidth,
      barHeight,
      cornerRadius,
      true,
      false,
    );

    drawRoundedRect(
      canvasContext,
      rightX,
      canvas.height / 2,
      actualBarWidth,
      barHeight,
      cornerRadius,
      false,
      true,
    );
  }
}

function drawRoundedRect(
  context,
  x,
  y,
  width,
  height,
  radius,
  roundTop,
  roundBottom,
) {
  context.beginPath();

  if (roundTop) {
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
  } else {
    context.moveTo(x, y);
    context.lineTo(x + width, y);
  }

  if (roundBottom) {
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height,
    );
  } else {
    context.lineTo(x + width, y + height);
  }

  if (roundBottom) {
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
  } else {
    context.lineTo(x, y + height);
  }

  if (roundTop) {
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
  } else {
    context.lineTo(x, y);
  }

  context.closePath();
  context.fill();
}
